import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IPreSelectParams } from "../../../../Orchestrator/Types/Types/BookingTypes";
import { _eventBus } from "../../../../core/events/EventBus";

export class PreSelectSeatAction extends BaseAction<void, IPreSelectParams> {
    override async run(): Promise<void | null> {
        try {
            if (!this.params) {
                console.error("Missing parameters for PreSelectSeatAction");
                return;
            }

            const { preSelections = [], passengers = [], confirmedSeats = [], selectedSeats = [], bookingResponse, resetToConfirmed } = this.params;

            // If asked to reset to confirmed, use confirmed seats directly
            if (resetToConfirmed) {
                updateRecoilState<Record<string, string>[]>("selectedSeatsAtom", (confirmedSeats as any) || []);
                return;
            }

            // Otherwise, if we already have confirmed seats present, do not overwrite
            const hasConfirmedSeats = Array.isArray(confirmedSeats)
                ? confirmedSeats.some(segment => segment && Object.keys(segment).length > 0)
                : Object.values(confirmedSeats || {}).some(segment => segment && Object.keys(segment).length > 0);

            if (hasConfirmedSeats) {
                return;
            }

            const newSelectedSeats: Record<string, string>[] = [];

            if (!Array.isArray(preSelections)) {
                console.error("Invalid placeMapResponse: expected an array");
                return;
            }

            preSelections.forEach((segment, segmentIndex) => {
                const segmentSelections = segment?.vehicleAvailability?.preSelections || [];
            
                if (!newSelectedSeats[segmentIndex]) {
                    newSelectedSeats[segmentIndex] = {};
                }
            
                segmentSelections.forEach((sel: any) => {
                    // privacy seating 
                    const isCompartmentPlace = sel.place && (sel.place.startsWith('Q') || sel.place.startsWith('D'));
            
                    if (isCompartmentPlace) {
                        const coach = segment?.vehicleAvailability?.vehicle?.coaches?.find(
                            (c: any) => c.number === sel.coach
                        );
            
                        if (coach) {
                            const compartment = coach.compartments?.find(
                                (comp: any) => comp.number === sel.place
                            );
            
                            if (compartment && compartment.places) {
                                let matchedPassengerIds: string[] = [];

                                for (const offer of bookingResponse.booking.bookedOffers) {
                                    for (const reservation of offer.reservations) {
                                        if (reservation.id === sel.reservationId) {
                                            matchedPassengerIds = reservation.passengerIds
                                                .filter((passengerId: string) => passengers.some(p => p.id === passengerId));
                                            break;
                                        }
                                    }
                                    if (matchedPassengerIds.length > 0) break;
                                }
                                compartment.places.forEach((place: any, placeIndex: number) => {
                                    if (matchedPassengerIds.length > 0) {
                                        const passengerIndex = matchedPassengerIds.length === 1
                                            ? 0
                                            : placeIndex % matchedPassengerIds.length;
                                        const passengerId = matchedPassengerIds[passengerIndex];
                                        newSelectedSeats[segmentIndex][`${sel.coach}-${place.number}`] = passengerId;
                                    }
                                });
                            }
                        }
                    } else {
                        let matchedPassengerId: string | undefined;

                        for (const offer of bookingResponse.booking.bookedOffers) {
                            for (const reservation of offer.reservations) {
                                if (reservation.id === sel.reservationId) {
                                    const passengerId = reservation.passengerIds[0]; // assuming 1 passenger per reservation
                                    const passenger = passengers.find(p => p.id === passengerId);

                                    if (passenger) {
                                        matchedPassengerId = passenger.id;
                                        break;
                                    }
                                }
                            }
                            if (matchedPassengerId) break;
                        }

                        if (matchedPassengerId) {
                            newSelectedSeats[segmentIndex][`${sel.coach}-${sel.place}`] = matchedPassengerId;
                        }
                    }
                });
            });

            updateRecoilState<Record<string, string>[]>("selectedSeatsAtom", newSelectedSeats);
        } catch (error) {
            console.error("Error in PreSelectSeatAction:", error);
        }
    }
}

export const preSelectSeatAction = new PreSelectSeatAction();